import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { UserRow, UserRowType } from '../../helpers/users-access-page.helpers';

@Component({
    selector: 'juyo-user-avatar',
    styleUrl: './user-avatar.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @if (type() === UserRowType.Invite) {
            <div class="avatar avatar--invite" [class.avatar--lg]="size() === 'lg'">
                <span class="material-symbols-outlined">mail</span>
            </div>
        } @else {
            <div
                class="avatar"
                [class.avatar--lg]="size() === 'lg'"
                [style.background-color]="bgColor()"
            >{{ initials() }}</div>
        }
    `,
})
export class UserAvatarComponent {
    public id = input.required<string>();
    public firstName = input.required<string>();
    public lastName = input.required<string>();
    public type = input<UserRowType>(UserRowType.User);
    public size = input<'sm' | 'lg'>('sm');
    public useFixedColor = input<boolean>(false);

    protected initials = computed(() => getInitials(this.firstName(), this.lastName()));
    protected bgColor = computed<string>(() => {
        if (this.useFixedColor()) {
            return '#9685E4';
        } else {
            return getAvatarColor(this.id());
        }
    });

    protected readonly UserRowType = UserRowType;
}

const AVATAR_COLORS = ['#6366f1', '#8b5cf6', '#ec4899', '#f59e0b', '#10b981', '#3b82f6', '#ef4444'];


function getInitials(firstName: string, lastName: string): string {
    return `${firstName?.[0] ?? ''}${lastName?.[0] ?? ''}`.toUpperCase() || '?';
}

function getAvatarColor(id: string): string {
    const hash = id.split('').reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
    return AVATAR_COLORS[hash % AVATAR_COLORS.length];
}
